import { FC, useCallback, useState } from 'react'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import ConfirmModalComponent from 'components/features/pfm/ConfirmModal/ConfirmModal'
import * as moment from 'moment'
import { unlinkHomeActionCreator } from 'actions/propertyActions'

type HouseUnlinkHandlerProps = {
  homeId: number
  onConfirm?: () => void
}
export const HouseUnlinkHandler: FC<HouseUnlinkHandlerProps> = (props) => {
  const { children, homeId, onConfirm } = props

  const [isConfirmShown, setIsConfirmShown] = useState(false)
  const showConfirm = useCallback(() => setIsConfirmShown(true), [])
  const hideConfirm = useCallback(() => setIsConfirmShown(false), [])

  const dispatch = useStoreDispatch()
  const handleConfirm = useCallback(() => {
    hideConfirm()
    dispatch(unlinkHomeActionCreator(homeId, moment().toISOString()))
    onConfirm && onConfirm()
  }, [dispatch, homeId, hideConfirm, onConfirm])

  return (
    <>
      <span onClick={ showConfirm }>
        { children }
      </span>
      { isConfirmShown && (
        <ConfirmModalComponent onCancel={ hideConfirm } onConfirm={ handleConfirm } confirmButtonText='Unlink'>
          Unlinking this home preserves its historical data, but removes it from current and future assets. Are you sure you want to unlink this home?
        </ConfirmModalComponent>
      )}
    </>
  )
}
